






















import Stepper from '@/components/Stepper.vue'
import { IDialog, PalletPattern } from '@/model/index'
import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import { Pages } from '../../pages'

@Component({
  components: {
    Stepper: Stepper
  },
  computed: {
    ...mapGetters('palletpatterns', [
      'isLoading',
      'isLoaded',
      'selectedEntity',
      'steps'
    ])
  },
})
export default class EditPalletPattern extends Vue {
  private homeRouteLink: any = Pages.HOME.routeLink
  private viewRouteLink: any = Pages.VIEWPALLETPATTERNS.routeLink
  private selectedEntity!: PalletPattern

  get propId (): string {
    return this.$route.params.id
  }

  private async created () {
    this.$store.commit('palletpatterns/SET_NEW', false)
    await this.$store.dispatch('palletpatterns/getSelectedEntity', this.$route.params.id)
  }

  private validateStep (value: number) {
    this.$store.dispatch('palletpatterns/validateById', value)
  }

  private update (palletPattern: PalletPattern) {
    const payload = {
      guid: this.propId,
      palletPattern: palletPattern
    }
    this.$store.dispatch('palletpatterns/updatePalletPattern', payload)
  }

  private route () {
    this.$router.push(this.homeRouteLink)
  }

  private finish () {
    this.$router.push(this.viewRouteLink)
  }
}
